"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CustomDatePicker;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _form = require("@sharingapples/form");

var _components = require("@honeyguide/components");

require("./datepicker.scss");

require("@honeyguide/components/dist/components/DateRangePicker/Calendar.css");

var formatDate = function formatDate(formatTo) {
  return function (date) {
    return (0, _format["default"])(date, formatTo);
  };
};

var formatForApi = formatDate('YYYY-MM-DD');

function CustomDatePicker(props) {
  var startDateName = props.startDateName,
      endDateName = props.endDateName,
      placeholder = props.placeholder,
      label = props.label;

  var _useFormInput = (0, _form.useFormInput)(startDateName),
      _useFormInput2 = (0, _slicedToArray2["default"])(_useFormInput, 2),
      startDate = _useFormInput2[0],
      setStartDate = _useFormInput2[1];

  var _useFormInput3 = (0, _form.useFormInput)(endDateName),
      _useFormInput4 = (0, _slicedToArray2["default"])(_useFormInput3, 2),
      endDate = _useFormInput4[0],
      setEndDate = _useFormInput4[1];

  var handleApply = function handleApply(userSelectedStartDate, userSelectedEndDate) {
    setStartDate(formatForApi(userSelectedStartDate));
    setEndDate(formatForApi(userSelectedEndDate));
  };

  return _react["default"].createElement(_react["default"].Fragment, null, label && _react["default"].createElement("label", null, label), _react["default"].createElement(_components.DateRangePickerInput, {
    initialStartDate: startDate,
    initialEndDate: endDate,
    onApply: handleApply,
    inputProps: {
      placeholder: placeholder
    }
  }));
}